import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useSupabase } from './SupabaseProvider';

/**
 * Invalidates all React Query caches when the Supabase JWT token is refreshed
 * after the tab regains focus. This ensures stale data (fetched with an expired
 * token) gets replaced with fresh data.
 *
 * Must be rendered inside both SupabaseProvider and QueryClientProvider.
 */
export function TokenRefreshInvalidator() {
  const { tokenVersion } = useSupabase();
  const queryClient = useQueryClient();
  const prevVersionRef = useRef(tokenVersion);

  useEffect(() => {
    // Skip the initial render
    if (prevVersionRef.current === tokenVersion) return;
    prevVersionRef.current = tokenVersion;

    // Token was refreshed (tab regained focus) - invalidate all queries
    // so they refetch with the fresh token
    queryClient.invalidateQueries();
  }, [tokenVersion, queryClient]);

  return null;
}
